import React from 'react'

export default () => (
  <div>
    <h1>Hubs</h1>
  </div>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Hubs.js